<template>
    <div>
        <Mainlayout></Mainlayout>
    
        <CCol sm="12" class="bg-FAFAFA">
            <CCol sm="8" style="width: 90%;background-size: cover; margin: auto;color: #fff">
                <br /> <br /> <br /> <br /> <br />
                <CRow class="m-2" v-for="item in blogdetail" v-bind:key="item.Id">
                    <CCol sm="12">

                        <img v-if="item.filePath != null" :src="item.filePath" style="max-width:100%" class="border-16px" />
                                <img v-else src="../assets/img/DEFAULTBLOG.png" style="max-width:100%" class="border-16px"/>
                    </CCol>
    
                    <CCol sm="12">
                        <h5 class="mt-2 custom-16px-500 text-left font-color-696969 font-general-sans mt-3" style="color:#696969">{{ item.CreatedDate | moment("DD/MM/YYYY") }}</h5>
                        <h3 class="custom-48px-500 font-inter">{{ item.Title }}</h3>
                        <p class="font-inter font-color-171717" v-html="item.Contents"></p>
                    </CCol>
    
    
    
                </CRow>
    
            </CCol>
    
    
        </CCol>
    
        <Footerlayout></Footerlayout>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import MainlayoutLogin from "../containers/LoginHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        MainlayoutLogin,
        Footerlayout
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,
            isLanguagePopupVisible2: false,
           blogdetail: [],
           idBlog: this.$route.query.id,

        };
    },
    created() {},
    mounted() {
        this.getDetailBlogById(this.idBlog);
    },
    methods: {
       
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, { withCredentials: true });
                if (response.status === 200 && response.data) {
                    this.user = response.data;
                    this.Names = this.user.name;
                } else {
                    this.$router.push("ContactUs");
                    console.error("User info retrieval failed:", response.data.detail);
                }
            } catch (error) {
                this.$router.push("ContactUs");
                console.error("Error fetching user info:", error);
            }
        },
        async getDetailBlogById(id) {
            try {
                this.Busy = true;
                const response = await this.$API.get(`${this.$BlogPostById}?id=${id}`);
                if (response.status === 200) {
                    this.blogdetail = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
    }

};
</script>
